import "./RemoveNote.scss";
import { useTranslation } from "react-i18next";

function RemoveNote({ cancelRemoveNote, removeNote }) {
  const { t } = useTranslation();
  return (
    <div className="remove-note-content">
      <div className="modal-title">
        <div>{t("notes.modals.removeNote.title")}</div>
      </div>
      <div className="modal-body">
        <p>{t("notes.modals.removeNote.message")}</p>
      </div>
      <div className="modal-form-buttons">
        <button className="modal-button cancel" onClick={cancelRemoveNote}>
          {t("common.cancel")}
        </button>
        <button className="modal-button delete" onClick={removeNote}>
          {t("common.remove")}
        </button>
      </div>
    </div>
  );
}

export default RemoveNote;
